import { useAuth } from "@/context/AuthContext";

// Returns true if current user is allowed to perform `action` on `module`.
// Admins always allowed.
export function usePermission(module, action) {
  const { user } = useAuth();
  if (!user) return false;
  if (user.role === "admin") return true;
  const p = user.permissions || {};
  const row = p[module] || {};
  return !!row[action];
}
